// Things related to the scenes page
const Scenes = {
	messageIds: { main: 'sceneMessage1', details: 'sceneMessage2' },
	shareGroupID: null,
	inviteURL: null, // The invte URL that can be copied to the clipboard
	currentEntryData: null, // To store data of the scene being shared
	copyInviteURLtoClipboard: () => {
		if (Scenes.inviteURL) {
			CP.copyToClipboard(Scenes.inviteURL);
			CP.notify("Invite URL copied to clipboard", false);
		} else CP.showErrorMessage("Invite URL is not available.");
	},
	createInviteCode: async () => {
		if (Scenes.shareGroupID) {
			CP.notify("Generating new scene sharing code", true);
			let result = await Cloud.getNewInviteCode(Scenes.shareGroupID, 1); // Usage = 1 because it's a sharing group
			if (result.success) {
				CP.notify('New scene sharing code: ' + result.inviteCode, false);
				CP.getel('inviteCodeText').textContent = result.inviteCode;
			} else CP.showErrorMessage("Failed to get scene sharing code!");
		} else CP.showErrorMessage("Can't get a scene sharing code unless a sharing group has already been created.");
	},
	createSharingGroupAndCopy: async (entryData) => {
		const result = await CP.createShareGroupWithEntry(entryData, "Scene");
		if(result.success) {
			Scenes.shareGroupID = result.shareGroupID;
			CP.getel('inviteCodeText').textContent = result.inviteCode;
			Scenes.inviteURL = `${CP.getSiteBaseUrl()}/sharedscene.html?sharegroupid=${CP.getBytesAsURIComponent(Scenes.shareGroupID)}`;
			CP.showEl(CP.getel('sharingInfoDiv'));
		}
	},
	updateReadOnlyState: async function(isReadOnly) {
		const entryData = this.currentEntryData;
		if (!entryData) {
			CP.showErrorMessage("No scene selected for update.");
			return;
		}

		const readOnlyCheckbox = CP.getel('readOnlyCheckbox');
		readOnlyCheckbox.disabled = true;

		try {
			const groupInfo = await CP.retrieveEncryptionKeyAndCheckVersion();
			const objectName = Cloud.getEntryObjectName(entryData.entryValue, entryData.entryHash);
			const encryptionKey = Cloud.getEntryObjectEncryptionKey(entryData.entryValue, groupInfo.groupID);
			const nrOfParts = entryData.entryValue.File.NrOfParts;
			
			const getRes = await Cloud.getCloudFileBytes(objectName, encryptionKey, nrOfParts, groupInfo.version);
			if (!getRes.success) {
				throw new Error('Failed to download scene file for update.');
			}
			
			const decryptedBytes = getRes.decryptedBytes;
			const arkioFileInZip = await DataUtil.getFileInZipByEnding(decryptedBytes, ".arkio");
			if (!arkioFileInZip) {
				throw new Error('Could not find a .arkio file in the scene archive.');
			}
			
			const arkioFileBytes = await arkioFileInZip.async('uint8array');
			const preambleString = ArkioFileUtil.getArkioPreamble(arkioFileBytes);
			const preamble = JSON.parse(preambleString);
			preamble.ReadOnly = isReadOnly;
			
			const newPreambleString = JSON.stringify(preamble);
			const newArkioFileBlob = ArkioFileUtil.updateArkioPreamble(arkioFileBytes, newPreambleString);
			const newArkioFileBytes = new Uint8Array(await newArkioFileBlob.arrayBuffer());

			const zip = await DataUtil.loadZipArchive(decryptedBytes);
			zip.file(arkioFileInZip.name, newArkioFileBytes);
			const newZipBytes = await zip.generateAsync({ type: "uint8array" });

			const putRes = await Cloud.multipartUpload(groupInfo, newZipBytes, (message) => console.log(message), encryptionKey, objectName);

			if (putRes.success) {
				const message = isReadOnly ? "Scene marked as View Only" : "Scene marked as Editable";
				CP.notify(message, false);
			} else {
				throw new Error('Failed to upload updated scene file.');
			}

		} catch (error) {
			console.error("Error updating scene read-only state:", error);
			CP.showErrorMessage(error.message || 'An unexpected error occurred during the update.');
			readOnlyCheckbox.checked = !isReadOnly; // Revert checkbox state on failure
		} finally {
			readOnlyCheckbox.disabled = false;
		}
	},
	openShareDiv: async function(entryData) {
		this.panelManager.showDetailsPanel();
		this.setStaticText(true);
		this.currentEntryData = entryData;
		if (entryData.entryValue.File?.Filename != null)
			CP.getel('sceneName').textContent = Util.getFilenameWithoutExtension(entryData.entryValue.File.Filename);
		
		const readOnlyLoading = CP.getel('readOnlyLoading');
		const readOnlyContainer = CP.getel('readOnlyContainer');
		CP.showEl(readOnlyLoading);
		CP.hideEl(readOnlyContainer);

		const readOnlyCheckbox = CP.getel('readOnlyCheckbox');
		readOnlyCheckbox.checked = false; // Default to unchecked
		readOnlyCheckbox.disabled = true; // Disable until loaded
		readOnlyCheckbox.onchange = null; // Clear any previous handlers

		try {
			const groupInfo = await CP.retrieveEncryptionKeyAndCheckVersion();
			if (!groupInfo?.groupID) {
				CP.showErrorMessage('Could not retrieve group info.');
				return;
			}

			const objectName = Cloud.getEntryObjectName(entryData.entryValue, entryData.entryHash);
			const encryptionKey = Cloud.getEntryObjectEncryptionKey(entryData.entryValue, groupInfo.groupID);
			const nrOfParts = entryData.entryValue.File.NrOfParts;

			const getRes = await Cloud.getCloudFileBytes(objectName, encryptionKey, nrOfParts, groupInfo.version);

			if (getRes.success) {
				const decryptedBytes = getRes.decryptedBytes;
				
				// The downloaded file is likely a zip archive. Find the .arkio file inside it.
				const arkioFileInZip = await DataUtil.getFileInZipByEnding(decryptedBytes, ".arkio");

				if (arkioFileInZip) {
					const arkioFileBytes = await arkioFileInZip.async('uint8array');
					const preambleString = ArkioFileUtil.getArkioPreamble(arkioFileBytes);
					const preamble = JSON.parse(preambleString);
					readOnlyCheckbox.checked = preamble.ReadOnly;

					const label = readOnlyCheckbox.parentElement.querySelector('span');
					if (preamble.ProModel === true) {
						readOnlyCheckbox.disabled = false;
						readOnlyCheckbox.onchange = () => this.updateReadOnlyState(readOnlyCheckbox.checked);
						label.textContent = 'View only';
						label.classList.remove('disabled');
					} else {
						readOnlyCheckbox.disabled = true;
						label.textContent = 'View only (Enterprise feature)';
						label.classList.add('disabled');
					}
				} else {
					CP.showErrorMessage('Could not find a .arkio file in the downloaded scene archive.');
				}
			} else {
				CP.showErrorMessage('Failed to load scene file.');
			}

		} catch (error) {
			console.error("Error fetching or processing scene file:", error);
			CP.showErrorMessage('Error loading scene properties.');
		} finally {
			CP.hideEl(readOnlyLoading);
			CP.showEl(readOnlyContainer);
		}

		this.createSharingGroupAndCopy(entryData);
	}
};

Scenes.fillTable = CP.createStandardFillTable(
	Scenes,
	'ScenesTableBody',
	entry => entry.entryValue.File?.ArkioScene != null,
	(entryData) => Scenes.openShareDiv(entryData)
);

CP.setupPageWithPanels(Scenes, {
    mainPanelId: 'mainSceneDiv',
    detailsPanelId: 'shareDiv',
    backArrowId: 'scenesPanelBackArrow',
    fillTable: Scenes.fillTable,
    messageAreasContainerId: 'messageAreas',
    onDOMContentLoaded: () => {
        CP.setupCopyInviteCodeButton('copyButtonSpan', 'inviteCodeText', {
            copying: "Copying scene sharing code",
            copied: "Scene sharing code"
        });
    }
});
